import { render, staticRenderFns } from "./VulnerabilitaDialog.vue?vue&type=template&id=263673a4"
import script from "./VulnerabilitaDialog.vue?vue&type=script&lang=js"
export * from "./VulnerabilitaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports